module.exports = __webpack_public_path__ + "static/media/amber.830769f8.jpg";